import pencil from 'assets/icons/pencil.svg'
import { useState } from 'react'
import styles from '../AllStyle.module.scss'

const ManningTableInfo = () => {
  const [change, setChange] = useState(false)
  return (
    <div className={styles.wrapper}>
      <div style={{ width: '100%', height: '100%' }}>
        {change ? (
          <div className={styles.Design_true}>
            <div className={styles.DesignHeader}>
              <div className={styles.header_left}>
                <h4 className={styles.header_left_info}>Штатное расписание</h4>
              </div>
              <div className={styles.headerRight}></div>
            </div>

            <div className={styles.Design_change_block}>
              <div className={styles.Design_change_header}>
                <div className={styles.headerLeft}>
                  <p className={styles.header_text}>Подразделение</p>
                  <input
                    type="text"
                    className={styles.Design_info_Header_inp}
                  />
                </div>
              </div>

              <ul className={styles.Design_desc}>
                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>Должность</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>Категория</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>Форма оплаты</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>Количество единиц</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                  />
                </li>
                <div className={styles.change_btn}>
                  <button className={styles.change_btn_add}>
                    <p style={{ color: 'white' }}>Добавить еще</p>
                  </button>
                </div>
              </ul>
              <ul className={styles.Design_desc_footer}>
                <li className={styles.Design_list_footer}>
                  <p className={styles.Design_info_footer}>Ввести штат</p>
                  <input
                    type="text"
                    placeholder="Номер приказа"
                    className={styles.Design_info_change_inp}
                  />
                  <input
                    type="date"
                    className={styles.Design_info_change_inp}
                  />
                </li>

                <li className={styles.Design_list_footer}>
                  <p className={styles.Design_info_footer}>Вывести штат</p>
                  <input
                    type="text"
                    placeholder="Номер приказа"
                    className={styles.Design_info_change_inp}
                  />
                  <input
                    type="date"
                    className={styles.Design_info_change_inp}
                  />
                </li>
              </ul>

              <div className={styles.change_btn}>
                <button
                  onClick={() => setChange(false)}
                  className={styles.change_btn_Cancel}
                >
                  <p>Отмена</p>
                </button>
                <button className={styles.change_btn_save}>
                  <p style={{ color: 'white' }}>Сохранить Изменения</p>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.Design}>
            <div className={styles.DesignHeader}>
              <div className={styles.header_left}>
                <h4 className={styles.header_left_info}>Штатное расписание</h4>
              </div>
              <div className={styles.headerRight}>
                <img
                  src={pencil}
                  onClick={() => setChange(true)}
                  className={styles.headerRight_info}
                />
              </div>
            </div>

            <p
              style={{
                color: 'white',
                width: '80%',
                textAlign: 'left',
                margin: 'auto',
                marginLeft: '8%',
                marginTop: '15px',
              }}
            >
              Подразделение{' '}
            </p>
            <p
              style={{
                color: 'white',
                width: '80%',
                textAlign: 'left',
                margin: 'auto',
                marginLeft: '8%',
                marginTop: '15px',
              }}
            >
              ОРПО{' '}
            </p>
            <ul className={styles.Design_desc}>
              <li className={styles.Design_list}>
                <p className={styles.Design_title}>Должность</p>
                <p className={styles.Design_info}>Инженер-программист</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>Категория</p>
                <p className={styles.Design_info}>-</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>Форма оплаты</p>
                <p className={styles.Design_info}>Контракт</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>Количество единиц</p>
                <p className={styles.Design_info}>-</p>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default ManningTableInfo
